import { render, staticRenderFns } from "./ExtraContent.vue?vue&type=template&id=515033b2&scoped=true&"
import script from "./ExtraContent.vue?vue&type=script&lang=js&"
export * from "./ExtraContent.vue?vue&type=script&lang=js&"
import style0 from "./ExtraContent.vue?vue&type=style&index=0&id=515033b2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "515033b2",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VImg})
